import { Link } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

export default function Services() {
  const panels = [
    { k: "mens-studio", label: "Men's Studio", img: "https://images.unsplash.com/photo-1546664278-c0a27e0cdc88?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
    { k: "womens", label: "Women's Hair", img: "https://images.unsplash.com/photo-1495914510314-ba3164b1321f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" },
  ];
  const t = useTheme();
  return (
    <div data-testid="services-landing">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-10">
        <div className="text-[11px] tracking-[0.4em] uppercase opacity-70" style={{ color: t.primary }}>Services</div>
        <h1 className="mt-4 text-5xl sm:text-6xl" style={{ color: t.text }}>Choose your studio</h1>
        <p className="mt-4 max-w-xl opacity-75">Two distinct experiences, one philosophy: your hair, perfectly crafted.</p>
      </div>
      <section className="grid grid-cols-1 md:grid-cols-2 min-h-[70vh]">
        {panels.map(p => (
          <Link key={p.k} to={`/services/${p.k}`} className="relative overflow-hidden zoom-hover group" data-testid={`services-panel-${p.k}`}>
            <img src={p.img} alt={p.label} className="absolute inset-0 w-full h-full object-cover grayscale zoom-target" />
            <div className="absolute inset-0 bg-black/45 group-hover:bg-black/35 transition-colors" />
            <div className="relative z-10 h-full flex flex-col items-center justify-center text-white py-32">
              <h2 className="text-5xl sm:text-6xl" style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800 }}>{p.label}</h2>
              <span className="mt-6 text-xs tracking-[0.3em] uppercase border-b border-white pb-1">View Services</span>
            </div>
          </Link>
        ))}
      </section>
    </div>
  );
}
